/**
 * Slug — the user-facing URL path for a page. Validated as
 * URL-path-safe: only lowercase alphanumeric, hyphens, and forward
 * slashes. A leading slash is required, no trailing slash unless the
 * slug is just "/". No consecutive slashes, no `..`, no spaces.
 *
 * Examples:
 *   "/"             — homepage
 *   "/about"        — top-level page
 *   "/blog/post-1"  — nested page
 *
 * Slugs are immutable once claimed (per PLAN.md "Slugs are immutable
 * once claimed"). The schema validates shape only; uniqueness and
 * reservation are enforced at the builder-api boundary.
 */
import * as Schema from "effect/Schema";

const SlugPattern = /^\/$|^(\/[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/;

export const Slug = Schema.String.pipe(
  Schema.pattern(SlugPattern, {
    message: () =>
      "Slug must start with '/'; segments may contain lowercase a-z, 0-9, and hyphens (not leading/trailing); no consecutive slashes",
  }),
  Schema.brand("Slug"),
);
export type Slug = Schema.Schema.Type<typeof Slug>;
